module.exports = __webpack_public_path__ + "static/Stan-5fad10a5cc62c59ea429a5ce90191e2e.png";